
import { request } from '@/api/request'
import GlobalConfig from '@/global/config'
const checkResponse = res => {
  return new Promise((resolve, reject) => {
    if (res.status >= 200 && res.status < 300) {
      resolve(res.data);
    }
    reject(res.data);
  });
};
// 获取树形组织部门
export function getOrganizationList(params) {
  return request({
    url: `/api/organization/list?token=${GlobalConfig.getBaseToken()}`,
    method: 'get',
    params
  }).then(checkResponse)
}

// 移动部门
export function moveOrganization(params) {
  return request({
    url: `/api/organization/move?token=${GlobalConfig.getBaseToken()}`,
    method: 'put',
    params
  })
}

// 创建部门
export function createOrganization(data) {
  return request({
    url: `/api/organization/batch/create?token=${GlobalConfig.getBaseToken()}`,
    method: 'post',
    data
  })
}


// 修改部门
export function updateOrganization(params,data) {
  return request({
    url: `/api/organization/update?token=${GlobalConfig.getBaseToken()}`,
    method: 'put',
    params,
    data
  })
}

// 删除部门
export function deleteOrganization(params) {
  return request({
    url: `/api/organization/delete?token=${GlobalConfig.getBaseToken()}`,
    method: 'delete',
    params
  }).then(checkResponse)
}
// 获取员工列表
export function getStaffList(params) {
  return request({
    url: `/api/staff/list?token=${GlobalConfig.getBaseToken()}&companyId=${GlobalConfig.getCompanyId()}`,
    method: 'get',
    params
  }).then(checkResponse)
}

// 创建部门
export function createInvite(data) {
  return request({
    url: `/api/staff/batch/invite?token=${GlobalConfig.getBaseToken()}&companyId=${GlobalConfig.getCompanyId()}`,
    method: 'post',
    data
  })
}
// 创建子账号
export function createAccount(data) {
  return request({
    url: `/api/customer/company/account?companyId=${GlobalConfig.getCompanyId()}&token=${GlobalConfig.getBaseToken()}`,
    method: 'post',
    data
  })
}
// 批量创建子账号
export function batchCreateAccount(data) {
  return request({
    url: `/api/customer/insertCompanyAccount?companyId=${GlobalConfig.getCompanyId()}&token=${GlobalConfig.getBaseToken()}`,
    method: 'post',
    data
  })
}
// 禁用
export function staffLock(data) {
  return request({
    url: `/api/staff/lock?staffId=${data.staffId}&companyId=${GlobalConfig.getCompanyId()}&token=${GlobalConfig.getBaseToken()}`,
    method: 'put',
  })
}
// 离职
export function staffDimission(data) {
  return request({
    url: `/api/staff/dimission?staffId=${data.staffId}&companyId=${GlobalConfig.getCompanyId()}&token=${GlobalConfig.getBaseToken()}`,
    method: 'put',
  })
}
// 启用
export function staffVerify(data) {
  return request({
    url: `/api/staff/verify?staffId=${data.staffId}&companyId=${GlobalConfig.getCompanyId()}&token=${GlobalConfig.getBaseToken()}`,
    method: 'put',
  })
}
// 放弃邀请
export function staffGiveup(data) {
  return request({
    url: `/api/staff/giveup?staffId=${data.staffId}&companyId=${GlobalConfig.getCompanyId()}&token=${GlobalConfig.getBaseToken()}`,
    method: 'put',
  })
}
// 再次邀请
export function staffInvite(data) {
  return request({
    url: `/api/staff/invite?staffId=${data.staffId}&companyId=${GlobalConfig.getCompanyId()}&token=${GlobalConfig.getBaseToken()}`,
    method: 'put',
  })
}
// 删除子账号
export function staffAccountDelete(data) {
  return request({
    url: `/api/staff/account/delete?staffId=${data.staffId}&companyId=${GlobalConfig.getCompanyId()}&token=${GlobalConfig.getBaseToken()}`,
    method: 'put',
  })
}
// 审核通过
export function staffReviewJoin(data) {
  return request({
    url: `/api/staff/batch/review/join?companyId=${GlobalConfig.getCompanyId()}&staffs=${data.staffs}&companyId=${GlobalConfig.getCompanyId()}&token=${GlobalConfig.getBaseToken()}`,
    method: 'put',
  })
}
// 审核不通过
export function staffBatchGiveup(data) {
  return request({
    url: `/api/staff/batch/giveup?companyId=${GlobalConfig.getCompanyId()}&staffs=${data.staffs}&companyId=${GlobalConfig.getCompanyId()}&token=${GlobalConfig.getBaseToken()}`,
    method: 'put',
  })
}
// 重置子账户密码
export function staffAccountPassword(data) {
  return request({
    url: `/api/customer/company/account/password?companyId=${GlobalConfig.getCompanyId()}&token=${GlobalConfig.getBaseToken()}`,
    method: 'put',
    data
  })
}

// 编辑员工
export function staffUpdate(params,data) {
  return request({
    url: `/api/staff/update?staffId=${params.staffId}&companyId=${GlobalConfig.getCompanyId()}&token=${GlobalConfig.getBaseToken()}`,
    method: 'put',
    data
  })
}
// 编辑子账号
export function staffAccountUpdate(data) {
  return request({
    url: `/api/customer/company/account/update?companyId=${GlobalConfig.getCompanyId()}&token=${GlobalConfig.getBaseToken()}`,
    method: 'put',
    data
  })
}
// 查询角色列表
export function queryStaffRoleAll(data) {
  return request({
    url: `/admin/staffRole/queryStaffRoleAll?companyId=${GlobalConfig.getCompanyId()}&token=${GlobalConfig.getBaseToken()}`,
    method: 'get',
    data
  })
}
// 修改角色
export function updateStaffRoleOnStaff(data) {
  return request({
    url: `/admin/staffRole/updateStaffRoleOnStaff?token=${GlobalConfig.getBaseToken()}`,
    method: 'post',
    data
  })
}
// 批量添加
export function organCreate(data) {
  return request({
    url: `/api/staff/batch/organ/create?organIds=${data.organIds}&staffIds=${data.staffIds}&companyId=${GlobalConfig.getCompanyId()}&token=${GlobalConfig.getBaseToken()}`,
    method: 'post',
    // data
  })
}
// 批量移动
export function organMove(data) {
  return request({
    url: `/api/staff/batch/organ/move?organIds=${data.organIds}&staffIds=${data.staffIds}&companyId=${GlobalConfig.getCompanyId()}&token=${GlobalConfig.getBaseToken()}`,
    method: 'post',
    // data
  })
}
// 管理员列表
export function companyAdminsPage(params) {
  return request({
    url: `/api/company/admins/page?companyId=${GlobalConfig.getCompanyId()}&token=${GlobalConfig.getBaseToken()}`,
    method: 'get',
    params
  })
}
// 企业部门及部门员工信息树
export function getStaffInfo(params) {
  return request({
    url: `/api/organization/company/staff/info?companyId=${GlobalConfig.getCompanyId()}&token=${GlobalConfig.getBaseToken()}`,
    method: 'get',
    params
  })
}
// 添加管理员
export function adminCreate(data) {
  return request({
    url: `/api/company/admins/create?staffIds=${data.staffIds}&companyId=${GlobalConfig.getCompanyId()}&token=${GlobalConfig.getBaseToken()}`,
    method: 'post',
    // params
  })
}
// 修改管理员
export function adminEdit(data) {
  return request({
    url: `/api/staff/edit/name?staffId=${data.staffId}&name=${data.name}&companyId=${GlobalConfig.getCompanyId()}&token=${GlobalConfig.getBaseToken()}`,
    method: 'put',
    // params
  })
}
// 删除管理员
export function adminsDelete(data) {
  return request({
    url: `/api/company/admins/delete?staffId=${data.staffId}&companyId=${GlobalConfig.getCompanyId()}&token=${GlobalConfig.getBaseToken()}`,
    method: 'put',
    // params
  })
}
// 查询角色列表
export function queryStaffRoleList(params) {
  return request({
    url: `/admin/staffRole/queryStaffRoleList?companyId=${GlobalConfig.getCompanyId()}&token=${GlobalConfig.getBaseToken()}`,
    method: 'get',
    params
  })
}
// 添加角色
export function addStaffRole(data) {
  return request({
    url: `/admin/staffRole/addStaffRole?token=${GlobalConfig.getBaseToken()}`,
    method: 'post',
    data
  })
}
// 修改角色
export function updateStaffRoleOragnization(data) {
  return request({
    url: `/admin/staffRole/updateStaffRoleOragnization?token=${GlobalConfig.getBaseToken()}`,
    method: 'post',
    data
  })
}
// 删除角色
export function deleteRoleById(params) {
  return request({
    url: `/admin/staffRole/deleteRoleById?token=${GlobalConfig.getBaseToken()}`,
    method: 'get',
    params
  })
}
// 获取父级节点子部门集合
export function quetyListByParentId(params) {
  return request({
    url: `/api/organization/quetyListByParentId?token=${GlobalConfig.getBaseToken()}`,
    method: 'get',
    params
  })
}


